import createIcon from '../../createIcon';

/**
 * @component @name PlayDisabled
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNOC41IDQuNjlWNC41TDE5LjUgMTEuNUwxNi45NSAxMy4xM0w4LjUgNC42OVpNMjAuNSAxOS4yM0w0Ljc3IDMuNUwzLjUgNC43N0w4LjUgOS43N1YxOC41TDEzLjgzIDE1LjFMMTkuMjMgMjAuNUwyMC41IDE5LjIzWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const PlayDisabled = createIcon('PlayDisabled', [
  [
    'path',
    {
      d: 'M8.5 4.69V4.5L19.5 11.5L16.95 13.13L8.5 4.69ZM20.5 19.23L4.77 3.5L3.5 4.77L8.5 9.77V18.5L13.83 15.1L19.23 20.5L20.5 19.23Z',
      key: 'lni8ow',
    },
  ],
]);

export default PlayDisabled;
